import { IPOMessage, IPOUtils } from '@hylaa-npm/ipod';
import { getClientRefreshToken } from '@/apis/login';
import { getStorage } from '@/utils/storage';
import i18next from 'i18next';

// 去掉具体页面
export const toProjectDetail: (client: ISplitEnd, projectId: string, isRead: boolean) => void = (
	client,
	projectId,
	isRead,
) => {
	const refreshToken = getStorage('refreshToken');
	if (!refreshToken) return;
	if (client.connectState === 0) {
		return IPOMessage.error(i18next.t('common.serverOffLine'));
	}
	getClientRefreshToken(client.id, refreshToken).then(() => {
		const url = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : client.url;

		const open = window.open(
			`${url}/s2/project.htm?projectId=${IPOUtils.encrypted(
				projectId,
			)}&refreshToken=${IPOUtils.encrypted(refreshToken)}&isRead=${IPOUtils.encrypted(
				isRead.toString(),
			)}&isCenter=${IPOUtils.encrypted(true.toString())}`,
			'_self',
		);
		window.addEventListener('message', (e) => {
			try {
				let data = JSON.parse(e.data);
				if (data.flag) {
					open &&
						open.postMessage(
							JSON.stringify({
								lang: getStorage('lang') || 'ZH',
							}),
							'*',
						);
				}
			} catch {}
		});
	});
};

// 打开概览页面
export const toProjectOverview: (client: ISplitEnd, projectId: string) => string = (
	client,
	projectId,
) => {
	return `${client.url}/s2/project-overview.htm?projectId=${IPOUtils.encrypted(projectId)}`;
};
